import { getPathRegex } from '../../utils/paths';
import { getNamedParamFromProps } from '../../utils/props';
import { getCurrentStep } from './getCurrentStep';

export const getParamsFromPath = (config, props) => {
  const current = getCurrentStep(config, props);
  const stepPath = getNamedParamFromProps(props.appPath, props);
  const [re, regexpKeys] = getPathRegex(current.path);
  const regexResults = re.exec(stepPath);
  const results = {};
  regexpKeys.forEach((regexpKey, index) => {
    results[regexpKey.name] = regexResults[index + 1];
  });
  return results;
};
